import Login from 'components/Login'
import ResetPassword from 'components/ResetPassword'
import ForgotPassword from 'components/ForgotPassword'
import Navbar from 'components/Navbar'
import Sidebar from 'components/Sidebar'
import { CompanyProvider } from 'context/CompanyContext'
import { ModalProvider } from 'context/ModalContext'
import { PaymentTypeProvider } from 'context/PaymentTypeContext'
import { ProductProvider } from 'context/ProductContext'
import { TaxProvider } from 'context/TaxContext'
import { SessionConsumer, SessionProvider } from 'context/SessionContext'
import { SidebarConsumer, SidebarProvider } from 'context/SidebarContext'
import { createBrowserHistory } from 'history'
import React from 'react'
import Relay from 'react-relay'
import { Route, Router, Switch } from 'react-router-dom'
import AppRouter from './AppRouter'
import { RefreshCountsProvider } from 'context/RefreshCountsContext'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import './utils/notificationTest'

const history = createBrowserHistory()

export default function App() {
  return (
    <SessionProvider>
      <SessionConsumer>
        {({ isAuth }) => (
          <Router history={history} environment={Relay.Store}>
            <RefreshCountsProvider>
              {isAuth ? (
                <SidebarProvider>
                  <ModalProvider>
                    <div className='amber-ui'>
                      <Sidebar />
                      <SidebarConsumer>
                        {({ isOpen }) => (
                          <div
                            id='amber-content'
                            className={'amber-content' + (isOpen ? '' : ' amber-content-full-width')}
                          >
                            <Navbar />
                            <CompanyProvider>
                              <PaymentTypeProvider>
                                <ProductProvider>
                                  <TaxProvider>
                                    <Switch>
                                      <AppRouter />
                                    </Switch>
                                  </TaxProvider>
                                </ProductProvider>
                              </PaymentTypeProvider>
                            </CompanyProvider>
                          </div>
                        )}
                      </SidebarConsumer>
                    </div>
                  </ModalProvider>
                </SidebarProvider>
              ) : (
                <Switch>
                  <Route path="/forgot-password" component={ForgotPassword} />
                  <Route path="/reset-password/:token" component={ResetPassword} />
                  <Route component={Login} />
                </Switch>
              )}
            </RefreshCountsProvider>
          </Router>
        )}
      </SessionConsumer>
    </SessionProvider>
  )
}